// extracted by mini-css-extract-plugin
export default {"protected-container":"style_protected-container__2+KIp","component":"style_component__cZNnA"};